export const validationVimeoLink = (link: string): boolean => {
  const patron = /https?:\/\/player\.vimeo\.com\/video\/(\d+)/;
  return patron.test(link);
};
